import React, { useState } from "react";
import {
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  UncontrolledDropdown,
} from "reactstrap";
import {
  ChevronDownIcon,
  EllipsisVerticalIcon,
  TrashIcon,
  UserPlusIcon,
  PlusIcon,
} from "@heroicons/react/20/solid";
import ShareListModal from "./modals/shareCreatorListModal";
import history from "../../history";
import { connect } from "react-redux";

const CreatorListsDropdown = ({ creatorList, deleteCreatorList, dropdownStyle = "icon", loginUser, ...props }) => {
  const [shareListView, setShareListView] = useState(false);

  const toggleShareListView = () => {
    setShareListView(!shareListView);
  };

  return (
    <UncontrolledDropdown className="creator-list-dropdown">
      <ShareListModal
        isOpen={shareListView}
        toggleModal={toggleShareListView}
        creatorList={creatorList}
        key={`${creatorList?._id}-share`}
      />
      <DropdownToggle
        className={`btn btn-dropdown mr-4 ${
          dropdownStyle === "button"
            ? "btn-default btn-dropdown-white btn-outline-primary"
            : ""
        }`}
        id={`action-popover-${creatorList._id}`}
      >
        {dropdownStyle === "button" ? (
          <>
            Actions
            <ChevronDownIcon
              className="icon-btn"
              width={20}
              height={20}
              strokeWidth={2}
            />
          </>
        ) : (
          <EllipsisVerticalIcon
            className="icon-btn"
            width={20}
            height={20}
            strokeWidth={2}
          />
        )}
      </DropdownToggle>
      <DropdownMenu className="creator-dropdown-menu">
        <DropdownItem
          className="btn btn-popover"
          onClick={() => toggleShareListView()}
        >
          <UserPlusIcon width={20} height={20} strokeWidth={2}></UserPlusIcon>
          <span>Share</span>
        </DropdownItem>
        <DropdownItem
          disabled={creatorList.listOwner?._id && creatorList.listOwner._id !== loginUser?.id && !creatorList.canSharedUsersEdit}
          className="btn btn-popover"
          onClick={() => history.push("/discovery")}
        >
          <PlusIcon width={20} height={20} strokeWidth={2}></PlusIcon>
          <span>Add Creators</span>
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem
          className="btn btn-popover delete"
          onClick={() => deleteCreatorList(creatorList._id)}
        >
          <TrashIcon width={20} height={20} strokeWidth={2}></TrashIcon>
          <span>Delete</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

const mapStateToProps = (state) => {
  return {
    loginUser: state.login.loginUser,
  };
};

export default connect(mapStateToProps, {})(CreatorListsDropdown);
